import { z } from 'zod';

/////////////////////////////////////////
// ADDRESS SCHEMA
/////////////////////////////////////////

export const AddressSchema = z.object({
  addressId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  addressType: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  streetNum: z.string(),
  street: z.string(),
  apartment: z.string(),
  address2: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  phone: z.string(),
  altPhone: z.string(),
  email: z.string(),
  note: z.string(),
  alert: z.string(),
  company: z.string(),
  streetOrig: z.string(),
  vehicleId: z.number().int(),
  externalId: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type Address = z.infer<typeof AddressSchema>

export default AddressSchema;
